'use strict';
import React from 'react';
import {buildFormHOC} from '../../../components/forms/Form';
import {INPUT_TYPES} from '../../../components/forms/FormField';
import {ProjectFormView} from './ProjectFormView';


export const ProjectFormComponent = buildFormHOC(ProjectFormView, {
  fields: [{
    property: 'name',
    type: INPUT_TYPES.text,
    constraints: {nullable: false},
    canEdit: true,
    useError: true,
  }, {
    property: 'isPrivate',
    type: INPUT_TYPES.checkbox,
    constraints: {},
    canEdit: (_, props) => props.canEditIsPrivate,
    useError: true,
  }, {
    property: 'description',
    type: INPUT_TYPES.text_long,
    constraints: {nullable: true},
    canEdit: true,
    useError: true,
  }],
});

// TODO: set up camera override settings
// {
//   property: 'overrideCameraSettings',
//     type: INPUT_TYPES.checkbox,
//   constraints: {nullable: true},
//   canEdit: true,
//     useError: true,
// }, {
//   property: 'cameraResolution',
//     type: INPUT_TYPES.select, // TODO: setup select type using the Dropdown component
//     constraints: {nullable: true},
//   canEdit: true,
//     useError: true,
// }, {
//   property: 'jpgQuality',
//     type: INPUT_TYPES.number,
//     constraints: {nullable: true},
//   canEdit: true,
//     useError: true,
// }



// WEBPACK FOOTER //
// ./src/js/projects/components/ProjectForm/ProjectFormComponent.js